var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-dialog-form',_vm._b({attrs:{"columns":_vm.columns},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},'bean-dialog-form',_vm.$attrs,false),[_c('el-button',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }